'use strict';

module.exports = function(currencyString = 0) {

	let value = currencyString.replace(/[^0-9\.]+/g, '');
	value = parseFloat(value);

	return isNaN(value) ?
	 	0 :
		value;

};